export const NAME = 'cornerStapleMachines';